import GigsStore from '@/stores/gigsStore';

// Initialize the engagement banner random position once on app startup
GigsStore.gigsActions.randomizeEngagementBannerPosition();
